// extracted by mini-css-extract-plugin
module.exports = {"numbers":"Paginado_numbers__3ua09","btn":"Paginado_btn__2hULB","sub":"Paginado_sub__1cADs","name":"Paginado_name__3UH7B","letra":"Paginado_letra__3x2YD"};